import { motion } from 'framer-motion';
import { ArrowDown, Phone } from '@phosphor-icons/react';
import { useCookieConsent } from '../context/CookieConsentContext';

const HeroSection = () => {
  const { trackEvent } = useCookieConsent();

  const scrollToForm = () => {
    const formSection = document.getElementById('lead-form');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handlePhoneClick = () => {
    trackEvent('Contact', { contact_method: 'phone_hero' });
  };

  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section">

      {/* Background Image - Deutsche Reihenhaussiedlung */}
      <div className="absolute inset-0">
        <img
          src="https://customer-assets.emergentagent.com/job_wohntraum-leads/artifacts/usmuqk7s_IMG_1660%202.jpg"
          alt="Saniertes Reihenhaus - Wohntraum Experten"
          className="w-full h-full object-cover" />

        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-dark" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}>

          {/* Logo/Brand */}
          <div className="mb-8">
            <span className="text-gold font-sans text-sm uppercase tracking-[0.3em]">
              Wohntraum Experten
            </span>
            <p className="text-white/50 text-xs mt-1 tracking-wide">by venta immobilien</p>
          </div>

          {/* Main Headline */}
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl xl:text-7xl text-white mb-6 leading-tight">
            Schlüsselfertige
            <br />
            <span className="text-gold-gradient">Komplettsanierung</span>
          </h1>

          {/* Subheadline */}
          <p className="font-sans text-lg sm:text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            Modern, effizient, wertsteigernd — <br className="hidden sm:block" />
            Alles aus einer Hand für Ihr neues Zuhause
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <motion.button
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              onClick={scrollToForm}
              className="bg-gold text-black font-medium uppercase tracking-wide text-sm px-8 py-4 hover:bg-gold-light transition-all w-full sm:w-auto"
              data-testid="hero-cta-primary">

              Kostenlose Beratung anfragen
            </motion.button>

            <a
              href="tel:+4921293758775"
              onClick={handlePhoneClick}
              className="flex items-center gap-2 border border-white/20 text-white font-medium uppercase tracking-wide text-sm px-8 py-4 hover:bg-white hover:text-black transition-all w-full sm:w-auto justify-center"
              data-testid="hero-phone-cta">

              <Phone size={18} weight="light" />
              02129/375877-5
            </a>
          </div>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.5, duration: 0.5 }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2">

          <motion.div
            animate={{ y: [0, 8, 0] }}
            transition={{ repeat: Infinity, duration: 1.5 }}
            className="cursor-pointer"
            onClick={scrollToForm}>

            <ArrowDown size={24} className="text-white/50" weight="light" />
          </motion.div>
        </motion.div>
      </div>

      {/* Trust Badges */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 0.6 }}
        className="absolute bottom-20 left-0 right-0 hidden lg:block">

        <div className="max-w-7xl mx-auto px-8">
          <div className="flex justify-center gap-12 text-white/50 text-sm">
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-gold rounded-full" />
              <span>20 Jahre Erfahrung</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-gold rounded-full" />
              <span>Festpreisgarantie</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2 h-2 bg-gold rounded-full" />
              <span>Ein Ansprechpartner</span>
            </div>
          </div>
        </div>
      </motion.div>
    </section>);

};

export default HeroSection;